var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOrgchart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 20,
    viewBox: "0 0 22 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 0V6H10V9H4C2.89 9 2 9.89 2 11V14H0V20H6V14H4V11H10V14H8V20H14V14H12V11H18V14H16V20H22V14H20V11C20 9.89 19.11 9 18 9H12V6H14V0H8Z",
    fill: "#5C5D6F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrgchart);
export default __webpack_public_path__ + "static/media/orgchart.2be04b93d1a76625e3997684dd6017c5.svg";
export { ForwardRef as ReactComponent };